import { toMoney as toMoneyCore } from '@rdss/core'
import { Component, Host, JSX, Prop, h } from '@stencil/core'

@Component({
    tag: 'zr-price',
    styleUrl: 'zr-price.scss',
    shadow: true,
})

/**
 * ZooRoyal price component.
 */
export class ZrPrice {

    /**
     * The so called "UVP" information.
     */
    @Prop() recommendedRetailPrice: number

    /**
     * Value of the actual product price.
     */
    @Prop() gross: number

    /**
     * Currency of the current shop as string.
     */
    @Prop() currency: string

    /**
     * Locale for number/currency formatting.
     */
    @Prop() locale = 'de-DE'

    /**
     * Unit for the "price per unit" value.
     */
    @Prop() weightUnit: string

    /**
     * The reference unit amount of the product for the offer.
     */
    @Prop() referenceUnit: string

    /**
     * The reference amount of the product for the offer.
     */
    @Prop() referencePriceUnit: number

    /**
     * Shows the discount as a percentage value.
     */
    @Prop() pseudoPercent = 0

    /**
     * Display label for the UVP label.
     */
    @Prop() labelUvp = 'UVP'

    /**
     * Display Label for Total Price.
     */
    @Prop() isTotalPrice = false

    /**
     * Label for Total Price.
     */
    @Prop() totalPriceLabel = 'Gesamtpreis'

    /**
     * Display Label for Total Price.
     */
    @Prop() isPriceHighlight = false

    /**
     * Transform number to currency format.
     *
     * @param {number} value Number to transform.
     *
     * @returns {string} Formatted number.
     */
    private toMoney(value: number): string {
        return toMoneyCore(value, this.currency, this.locale)
    }

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class={{
                    'zr-price__wrapper': !this.isPriceHighlight,
                    'zr-price__wrapper zr-price__highlight': this.isPriceHighlight,
                }}>
                    <p class="zr-price__recommended-price">
                        {
                            this.isTotalPrice && this.totalPriceLabel
                        }
                        {
                            !this.isTotalPrice && (this.recommendedRetailPrice > this.gross) && this.pseudoPercent >= 5
                                ? <span>
                                    {this.labelUvp}&nbsp;{this.toMoney(this.recommendedRetailPrice)}
                                    <span class="zr-price__discount">&nbsp;(-{this.pseudoPercent}%)</span>
                                </span> : <span></span>
                        }
                    </p>
                    <p class="zr-price__current-price p-price">
                        {this.toMoney(this.gross)}
                    </p>
                    {(this.weightUnit && !['Stck.', 'Stück'].includes(this.weightUnit)) &&
                        <p class="zr-price__price-per-unit">
                            {this.toMoney(this.referencePriceUnit)}
                            &nbsp;/ {parseFloat(this.referenceUnit) > 1 ? ' ' + this.referenceUnit : ''}
                            <span class="zr-price__unit">{this.weightUnit}</span>
                        </p>
                    }
                </div>
            </Host>
        )
    }
}
